// extracted by mini-css-extract-plugin
export var button = "_dw-7";
export var buttonRow = "_dw-6";
export var fadeIn = "_dw-1";
export var gradient = "_dw-0";
export var panel = "_dw-2";
export var panelIn = "_dw-3";
export var subtitle = "_dw-5";
export var title = "_dw-4";